import { message } from "ant-design-vue";
import Icon from "ant-design-vue/es/icon";
import SvgIcon from "@/components/SvgIcon";
function autoImportSvg() {
  // 自动导入所有svg图标。
  const req = require.context("@/assets/icons/svg", false, /\.svg$/);
  const requireAll = (requireContext) => {
    requireContext.keys().map(requireContext);
  };
  requireAll(req)
}
export default function (Vue) {
  Vue.component("svg-icon", SvgIcon);
  autoImportSvg();
  const IconFont = Icon.createFromIconfontCN({
    scriptUrl: `/${process.env.VUE_APP_NAME}/assets/iconfont/iconfont.js`,
  });
  Vue.component("g-icon", IconFont);
  Vue.prototype.$formData = (params) => {
    const formData = new FormData();
    if (Object.prototype.toString.call(params) === "[object Object]") {
      for (const v in params) {
        if (Object.prototype.hasOwnProperty.call(params, v)) {
          formData.append(v, params[v]);
        }
      }
    }
    return formData;
  };
  Vue.prototype.$open = (url) => {
    window.open(url, "self");
  };
  Vue.prototype.$copy = (content) => {
    const save = function (e) {
      e.clipboardData.setData("text/plain", content);
      e.preventDefault(); // 阻止默认行为
      message.success("复制成功");
    };
    document.addEventListener("copy", save); // 添加一个copy事件
    document.execCommand("copy"); // 执行copy方法
    document.removeEventListener("copy", save); // 移除copy事件
  };
}
